import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import { formatSupabaseError, supabase } from "../lib/supabase";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const user = await login(email, password);

      // 1) Controlla se l'utente ha un ruolo nel gestionale (user_roles)
      const { data: gestionaleRole } = await supabase
        .from("user_roles")
        .select("role")
        .eq("user_id", user.id)
        .maybeSingle();

      if (gestionaleRole?.role) {
        navigate("/app");
        return;
      }

      // 2) Comportamento esistente del sito pubblico (invariato)
      const { data: prof } = await supabase
        .from("profiles")
        .select("role")
        .eq("id", user.id)
        .maybeSingle();
      navigate(prof?.role === "admin" ? "/admin" : "/dashboard");

    } catch (err) {
      setError(formatSupabaseError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 py-16 relative" data-testid="login-page">
      <div className="absolute inset-0 grid-pattern opacity-30" />
      <div className="relative w-full max-w-md">
        <div className="text-center mb-10">
          <div className="text-overline text-yellow-400 mb-3">// Bentornato</div>
          <h1 className="font-display font-black text-4xl uppercase tracking-tight">Accedi</h1>
        </div>
        <form onSubmit={onSubmit} className="rounded-2xl bg-zinc-900 border border-zinc-800 p-8 space-y-5" data-testid="login-form">
          {error && <div className="rounded-lg bg-red-500/10 border border-red-500/40 px-4 py-3 text-sm text-red-300" data-testid="login-error">{error}</div>}
          <div>
            <Label htmlFor="email" className="text-zinc-300">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e)=> setEmail(e.target.value)} className="bg-zinc-950 border-zinc-800 mt-1.5" data-testid="login-email" />
          </div>
          <div>
            <Label htmlFor="password" className="text-zinc-300">Password</Label>
            <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="bg-zinc-950 border-zinc-800 mt-1.5" data-testid="login-password" />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-yellow-400 text-zinc-950 hover:bg-yellow-300 font-display font-bold rounded-full" data-testid="login-submit">
            {loading ? "Accesso…" : "Accedi"}
          </Button>
        </form>
      </div>
    </div>
  );
}